<template>
    <div class="bindPage rightPage">
        <div class="layout">
            <v-search :formContent="formContent" :SearchForm="SearchForm" :inline="true" :optareBtn="optareBtn"
                :treePathObj="treePathObj" @resetFn="resetFn" @confirmFn="getListFn" @searchFn="getListFn"
                @stopFn="stopFn" />
            <div class="componentPage">
                <unbindTable :tableData="tableData" v-bind="$attrs" :loading="loading" @stopUseFn="stopUseFn"
                    @choozeTable="choozeTable" @historyFn="historyFn" @detailFn="detailFn" @dataHandleFn="dataHandleFn" />
                <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart"
                    :limit.sync="SearchForm.iDisplayLength" @pagination="getListFn"></Pagination>
            </div>
        </div>
    </div>
</template>

<script>
import getAllTreePath from '@/utils/getAllTreePath.js'
import bus from '@/utils/bus.js'
import unbindTable from './UnTablePage.vue'
import { baseList, updateBaseStatus } from '@/api/modules/base.js'
import { sBaseNo, sBaseType } from '../config/search'
import { baseHistory } from '@/utils/winDetail'
import { getIsPlatform, getPermission } from '@/utils/permission'

export default {
  mixins: [getAllTreePath],
  components: {
    unbindTable
  },
  props: {
    selectDeviceType: {
      type: Array
    }
  },
  computed: {
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      return getPermission()
    }
  },
  data () {
    return {
      formContent: [sBaseNo, sBaseType],
      SearchForm: {
        name: null,
        type: '',
        mac: null,
        carrierName: null,
        status: '',
        configStatus: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      },
      total: 0,
      loading: false,
      tableData: [],
      title: '',
      isShow: false,
      optareBtn: [
        // {
        //     id: 1,
        //     icon: '',
        //     vHas: ['incubatorAddCarrier'],
        //     text: 'public.stop',
        //     method: 'stopFn'
        // }
        // {
        //     id: 2,
        //     icon: '',
        //     vHas: ['incubatorAddCarrier'],
        //     text: 'public.net_param',
        //     method: 'netFn'
        // }
      ],
      choozeTableData: [],
      // 网络参数
      isShow: false,
      title: '',
      // 把表格的数据也传递过去
      rowData: {},
      // 详情
      isDetailShow: false,
      detailObj: {},
      // 属性的健名
      deviceType: {},
      // 属性的对应值
      deviceProperty: {},
      netObj: {}
    }
  },
  mounted () {
    bus.$off('nodeClickFn')
    bus.$on('nodeClickFn', row => {
      // 获取完整的路径
      this.getAllPath(row)
      this.treeClickSearchFn(row)
    })
    if (this.sysAdmin === 'noSysNoAdmin') {
      this.optareBtn.pop()
    }

    const allIndex = this.$store.getters.SchemaTree.findIndex(item => item.sceneCode === 'all_node')

    if (allIndex !== -1) {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
      this.treePathObj = this.$store.state.SchemaTree[1].label
    } else {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
      this.treePathObj = this.$store.state.SchemaTree[0].label
    }
    this.getListFn()
  },
  methods: {
    /** 分页 */
    getListFn (params) {
      this.loading = true
      baseList(this.SearchForm, 'unbind')
        .then(res => {
          const { result, pageInfo } = res.result

          this.tableData = result
          this.total = pageInfo.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    /** 点击树形查询 */
    treeClickSearchFn (row) {
      if (row.id === 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = null
      }
      // 一级范围
      else if (row.level === 0 && row.id !== 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = row.label
      } else {
        this.SearchForm.scopeName = null
        this.SearchForm.sceneId = row.sceneId
      }
      this.getListFn()
    },
    resetFn () {
      this.SearchForm = {
        name: null,
        type: null,
        mac: null,
        carrierName: null,
        scopeName: null,
        status: null,
        configStatus: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      }

      // item.way === 'unbind' || item.way === 'unknown'
      if (getIsPlatform()) {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
        this.treePathObj = this.$store.state.SchemaTree[1].label
      } else {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
        this.treePathObj = this.$store.state.SchemaTree[0].label
      }
      bus.$emit('initTree')
      this.getListFn()
    },
    choozeTable (row) {
      this.choozeTableData = row
    },
    /** 多条停用 */
    stopFn () {
      if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      const idList = this.choozeTableData.map(item => item.id)
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          // const query = qs.stringify({ ids: idList.join(','), status: 2 });
          updateBaseStatus(idList.join(','), 'unused').then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => { })
    },
    /** 单条停用 */
    stopUseFn (row) {
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          // const query = qs.stringify({ ids: row.id, status: 2 });
          updateBaseStatus(row.id, 'unused').then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => { })
    },

    /** 绑定历史 */
    historyFn (row) {
      bus.$emit('bindHistoryParam', row.id)
    },
    changdetail (row) {
      this.detailFn(row)
    },
    /** 详情 */
    detailFn (row) {
      bus.$emit('baseParam', row.id, row.plinthCode, this.getListFn)
    },
    dataHandleFn (row) {
      baseHistory(row.plinthCode)
    }
  }
}
</script>

<style lang="scss" scoped>
.bindPage {
    height: 100%;
    padding-right: 15px;
    box-sizing: border-box;

    .layout {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
    }

    .componentPage {
        flex: 1;

        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
}
</style>
